import { Chip, ChipProps, paletteColors } from '@evaneos/b2b-ui';

export const TAG_CHIP_COLOR = paletteColors.green[200]!;

export const TagChip = ({
    label,
    onDelete,
    ...chipProps
}: {
    label: string;
} & ChipProps) => (
    <>
        <Chip
            size="small"
            label={label}
            component="strong"
            sx={{
                backgroundColor: paletteColors.green[100],
                color: paletteColors.green[800],
                fontSize: '1.4rem',
                fontWeight: 400,
                padding: 0.5,
                '& .MuiChip-deleteIcon': {
                    color: paletteColors.neutral[600],
                    '&:hover': {
                        color: paletteColors.neutral[800],
                    },
                },
            }}
            onDelete={onDelete}
            {...chipProps}
        />
    </>
);
